const organization = {
    require_membership: '用户必须是组织的成员才能继续。',
};
export default Object.freeze(organization);
